import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName: string) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';
import React, { useEffect, useState } from 'react';
import { regroupModuleReducers } from '@rakutenfrance/redux-apollo-helper';

import { renderReact } from '../../fragmentHelper/renderReactCustom';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import '@rakutenfrance/crew-partner-modal/build/style.global.css';
import CrewPartnerModal from '@rakutenfrance/crew-partner-modal';
import { GetServerSideProps, GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';
import { configService as configurationService } from '@rakutenfrance/config-service';

export const serverCanCache = true;

const { CrewPartnerModalContainer } = CrewPartnerModal.containers;

const reducers = regroupModuleReducers([CrewPartnerModal] as any[]);

const ClientWrapperContainer = ({ advertCrewModale }: { advertCrewModale: any }): JSX.Element => {
  const [renderOnClient, setRenderOnClient] = useState(false);
  useEffect(() => {
    setRenderOnClient(true);
  }, []);
  return <div>{renderOnClient && <CrewPartnerModalContainer {...advertCrewModale} />}</div>;
};

const WrappedCrewPartnerModal: React.FC<PagePropsType & { graphQlvariables: any; advertCrewModale: any }> = ({
  initialApolloState,
  initialReduxState,
  moduleName,
  advertCrewModale,
}) => {

  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      moduleName={moduleName}
      reducers={reducers}
    >
      <ClientWrapperContainer advertCrewModale={advertCrewModale} />
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const renderFunction = renderReact('CrewPartnerModal', WrappedCrewPartnerModal);

export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext): Promise<GetServerSideProps> => {
  const advertCrewModale = configurationService.get().advertCrewModale;
  return {
    props: {
      advertCrewModale,
    },
  };
};
